import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import "../Login/Login.css";
import logo from "../../assets/dr-is-in.png";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://zvacumxidqqaueuruwnj.supabase.co";

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2YWN1bXhpZHFxYXVldXJ1d25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1NTk4ODQsImV4cCI6MjA5NDEzNTg4NH0.PkuVH1cMeGpG5GTckXBNuSdvWFwUij27s25M1MkKYgQ";

const supabase = createClient(supabaseUrl, supabaseAnonKey);

function StarRow({
  label,
  value,
  onChange,
  disabled,
}: {
  label: string;
  value: number;
  onChange: (n: number) => void;
  disabled?: boolean;
}) {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ fontSize: 12, fontWeight: 700, margin: "6px 0" }}>{label}</div>
      <div style={{ display: "flex", justifyContent: "center", gap: 6 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            className="login-btn"
            style={{ width: 44, padding: "8px 0", opacity: n <= value ? 1 : 0.55 }}
            onClick={() => onChange(n)}
            disabled={disabled}
          >
            ★
          </button>
        ))}
      </div>
    </div>
  );
}

export default function ContactUsSurvey() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const [q1, setQ1] = useState(5);
  const [q2, setQ2] = useState(5);
  const [q3, setQ3] = useState(5);
  const [q4, setQ4] = useState(5);
  const [q5, setQ5] = useState(5);
  const [q6, setQ6] = useState(5);

  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState<{ kind: "ok" | "err"; text: string } | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    setSubmitting(true);

    try {
      const survey = {
        q1,
        q2,
        q3,
        q4,
        q5,
        q6,
        created_at_client: new Date().toISOString(),
      };

      const surveyMessage = [
        "User Survey",
        "",
        `q1: ${q1}`,
        `q2: ${q2}`,
        `q3: ${q3}`,
        `q4: ${q4}`,
        `q5: ${q5}`,
        `q6: ${q6}`,
        "",
        JSON.stringify(survey, null, 2),
      ].join("\n");

      const { error } = await supabase.from("contacts").insert({
        contact_type: "survey",
        message: surveyMessage,
        created_by: "public_user",
      });

      if (error) throw error;

      setMsg({ kind: "ok", text: "Thanks — your survey was submitted." });
      setTimeout(() => navigate("/contact-us"), 700);
    } catch (e: any) {
      setMsg({ kind: "err", text: e?.message || "Submit failed." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Doctor Is In Logo" className="login-logo" />
        <h2 className="login-title">Survey</h2>
        <div className="login-tagline">Rate each item 1–5 stars.</div>

        {msg && (
          <div
            style={{
              width: "100%",
              margin: "10px 0",
              padding: "10px 12px",
              borderRadius: 10,
              fontSize: 13,
              border: "1px solid rgba(0,0,0,0.12)",
              background: msg.kind === "ok" ? "rgba(0,0,0,0.04)" : "rgba(255,0,0,0.10)",
              color: "#111",
              textAlign: "center",
            }}
          >
            {msg.text}
          </div>
        )}

        <form onSubmit={submit} className="login-actions">
          <StarRow label="1) Ease of login and navigation" value={q1} onChange={setQ1} disabled={submitting} />
          <StarRow label="2) Design and look/feel" value={q2} onChange={setQ2} disabled={submitting} />
          <StarRow label="3) Speed/performance" value={q3} onChange={setQ3} disabled={submitting} />
          <StarRow label="4) Helpfulness of wellness information" value={q4} onChange={setQ4} disabled={submitting} />
          <StarRow label="5) Safety/trust/comfort using the app" value={q5} onChange={setQ5} disabled={submitting} />
          <StarRow label="6) Overall satisfaction" value={q6} onChange={setQ6} disabled={submitting} />

          <button type="submit" className="login-btn" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Survey"}
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/contact-us")} disabled={submitting}>
            ← Back
          </button>
        </form>

        <div className="login-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
}